export default __webpack_public_path__ + "static/media/eye.8770f438.svg";